// TODO: Replace this file with real translations

const translations = {
    'new': 'nowy',
    'ksef': 'Zaciągnięte z KSeF',
    'inApproval': 'w trakcie zatwierdzania',
    'inMeritoricalApproval': 'w akceptacji merytorycznej',
    'inFormalApproval': 'w akceptacji formalnej',
    'approved': 'zatwierdzony',
    'printed': 'wydrukowany',
    'Print': 'Wydrukuj',
    'Approve': 'Zaakceptuj',
    'Reject': 'Odrzuć',
    'Update': 'Popraw',
    'Cancel': 'Anuluj',
    'Export': 'Wyeksportuj',
    'exported': 'wyeksportowano',
    'Return': 'Zwróć',
    'Mark as returned': 'Zwrócono',
    'readyToReturn': 'gotowy do wypłacenia',
    'returned': 'zwrócony',
    'settled': 'rozliczony',
    'rejected': 'odrzucony',
    'open': 'otwarta',
    'readyToClose': 'gotowa do zamknięcia',
    'readyToExport': 'gotowa do eksportu',
    'readyToPay': 'gotowa do wypłacenia',
    'Save': 'Zapisz zmiany',
    'closed': 'zamknięta',
    'canceled': 'anulowany',
    'additional': 'Dodatkowa',
    'static': 'Stała',
    'ROLE_ADMIN': 'administrator',
    'ROLE_MANAGER': 'manager',
    'ROLE_USER': 'użytkownik',
    'ROLE_STAFF': 'obsługa',
    'Send to approval': 'Przekaż do akceptacji',
    'Untitled': 'Bez nazwy',
    'Jan': 'Sty',
    'Feb': 'Lut',
    'Mar': 'Mar',
    'Apr': 'Kwi',
    'May': 'Maj',
    'Jun': 'Cze',
    'Jul': 'Lip',
    'Aug': 'Sie',
    'Sep': 'Wrz',
    'Oct': 'Paź',
    'Nov': 'Lis',
    'Dec': 'Gru',
    PENDING_ASSIGNMENT: 'Do przypisania',
    ASSIGNED: 'Przypisany',
    DESCRIBED: 'Opisany',
    CANCELLED: 'Anulowany',
    HRNEST_SETTLED: 'Anulowany (rozliczony w HRnest)',
};

export const translate = (source) => {
    return source && translations[source] !== undefined ? translations[source] : source;
};
